import type { ReportType } from './utils/reports.helpers';

const r2mExecutiveReport = {
	data: {
		aggregate: {
			totalJobs: 8,
			jobsAvg: 0.016563146997929608,
			topDevice: 'Stark IXL5',
			topUser: 'Dylan Crush',
		},
		bars: [
			{
				label: 'Users',
				value: 8,
			},
			{
				label: 'Jobs',
				value: 8,
			},
			{
				label: 'Simplex',
				value: 23,
			},
			{
				label: 'Duplex',
				value: 14,
			},
			{
				label: 'Devices',
				value: 2,
			},
		],
		table: {
			head: {
				releaserName: 'releaserName',
				filename: 'filename',
				siding: 'siding',
				deviceName: 'deviceName',
				_time: '_time',
			},
			rows: [
				{
					result: '_result',
					table: 0,
					_start: '2024-02-08T19:42:08Z',
					_stop: '2025-06-04T20:44:58Z',
					_time: '2025-05-14T00:00:00Z',
					_value: 4,
					_field: 'pages',
					_measurement: 'job',
					device_id: 'ed2037a6-bd4b-47d4-b93f-5d7204a8b434',
					deviceModel: 'Ford',
					deviceName: 'Stark IXL5',
					deviceSerialNumber: 'daaf06e0-ba3d-489b-b6d6-593d50e28a70',
					filename: 'trer',
					job_id: '032a9a7f-4d04-46a4-99ec-137ea8e34b16',
					queueName: 'My Print Queue',
					queueType: 'Personal',
					releaser_id: '0649d073-6434-449b-a0f0-9120e2166946',
					releaserName: 'Dylan Crush',
					siding: 'Simplex',
					submitter_id: '0649d073-6434-449b-a0f0-9120e2166946',
					submitterName: 'Dylan Crush',
					tenant_id: '8c7c258e-58c9-4796-a18b-61fc556cbae9',
				},
				{
					result: '_result',
					table: 1,
					_start: '2024-02-08T19:42:08Z',
					_stop: '2025-06-04T20:44:58Z',
					_time: '2025-05-14T00:00:00Z',
					_value: 1,
					_field: 'pages',
					_measurement: 'job',
					device_id: '6d4f4e56-681a-4e83-9470-6307b99bf172',
					deviceModel: 'Nissan',
					deviceName: 'KMBCI 260i',
					deviceSerialNumber: '3be5fb12-4216-4819-88b0-76041664d802',
					filename: 'asdf',
					job_id: '27dcb48a-f4e0-4762-a1c7-f5afb2f2380b',
					queueName: 'My Print Queue',
					queueType: 'Personal',
					releaser_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					releaserName: 'Peyton Smash',
					siding: 'Simplex',
					submitter_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					submitterName: 'Peyton Smash',
					tenant_id: '8c7c258e-58c9-4796-a18b-61fc556cbae9',
				},
				{
					result: '_result',
					table: 2,
					_start: '2024-02-08T19:42:08Z',
					_stop: '2025-06-04T20:44:58Z',
					_time: '2025-05-14T00:00:00Z',
					_value: 3,
					_field: 'pages',
					_measurement: 'job',
					device_id: '6d4f4e56-681a-4e83-9470-6307b99bf172',
					deviceModel: 'Nissan',
					deviceName: 'KMBCI 260i',
					deviceSerialNumber: '3be5fb12-4216-4819-88b0-76041664d802',
					filename: 'qwefzxcb',
					job_id: '54d0a0f6-3794-4660-ae63-78cd677b2190',
					queueName: 'Bill Print Queue',
					queueType: 'Shared',
					releaser_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					releaserName: 'Peyton Smash',
					siding: 'Simplex',
					submitter_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					submitterName: 'Peyton Smash',
					tenant_id: '8c7c258e-58c9-4796-a18b-61fc556cbae9',
				},
				{
					result: '_result',
					table: 3,
					_start: '2024-02-08T19:42:08Z',
					_stop: '2025-06-04T20:44:58Z',
					_time: '2025-05-14T00:00:00Z',
					_value: 8,
					_field: 'pages',
					_measurement: 'job',
					device_id: '6d4f4e56-681a-4e83-9470-6307b99bf172',
					deviceModel: 'Nissan',
					deviceName: 'KMBCI 260i',
					deviceSerialNumber: '3be5fb12-4216-4819-88b0-76041664d802',
					filename: 'df',
					job_id: '639a8950-88ea-408f-951b-2770e8ebaa08',
					queueName: 'My Print Queue',
					queueType: 'Personal',
					releaser_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					releaserName: 'Peyton Smash',
					siding: 'Duplex',
					submitter_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					submitterName: 'Peyton Smash',
					tenant_id: '8c7c258e-58c9-4796-a18b-61fc556cbae9',
				},
				{
					result: '_result',
					table: 4,
					_start: '2024-02-08T19:42:08Z',
					_stop: '2025-06-04T20:44:58Z',
					_time: '2025-05-14T00:00:00Z',
					_value: 5,
					_field: 'pages',
					_measurement: 'job',
					device_id: '6d4f4e56-681a-4e83-9470-6307b99bf172',
					deviceModel: 'Nissan',
					deviceName: 'KMBCI 260i',
					deviceSerialNumber: '3be5fb12-4216-4819-88b0-76041664d802',
					filename: 'qwer',
					job_id: 'd3895a2b-e2a0-4b8b-a56d-1ba274e775f8',
					queueName: 'My Print Queue',
					queueType: 'Personal',
					releaser_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					releaserName: 'Peyton Smash',
					siding: 'Simplex',
					submitter_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					submitterName: 'Peyton Smash',
					tenant_id: '8c7c258e-58c9-4796-a18b-61fc556cbae9',
				},
				{
					result: '_result',
					table: 5,
					_start: '2024-02-08T19:42:08Z',
					_stop: '2025-06-04T20:44:58Z',
					_time: '2025-05-14T00:00:00Z',
					_value: 2,
					_field: 'pages',
					_measurement: 'job',
					device_id: '6d4f4e56-681a-4e83-9470-6307b99bf172',
					deviceModel: 'Nissan',
					deviceName: 'KMBCI 260i',
					deviceSerialNumber: '3be5fb12-4216-4819-88b0-76041664d802',
					filename: 'asdf',
					job_id: 'ecc8e6c9-3d34-4d71-bb85-9448f7a867aa',
					queueName: 'Bill Print Queue',
					queueType: 'Shared',
					releaser_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					releaserName: 'Peyton Smash',
					siding: 'Simplex',
					submitter_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					submitterName: 'Peyton Smash',
					tenant_id: '8c7c258e-58c9-4796-a18b-61fc556cbae9',
				},
				{
					result: '_result',
					table: 6,
					_start: '2024-02-08T19:42:08Z',
					_stop: '2025-06-04T20:44:58Z',
					_time: '2025-05-14T00:00:00Z',
					_value: 8,
					_field: 'pages',
					_measurement: 'job',
					device_id: '6d4f4e56-681a-4e83-9470-6307b99bf172',
					deviceModel: 'Nissan',
					deviceName: 'KMBCI 260i',
					deviceSerialNumber: '3be5fb12-4216-4819-88b0-76041664d802',
					filename: 'qergdfgs',
					job_id: 'f3a88c2c-a67a-4a28-99dc-bcd16b4cc8e6',
					queueName: 'Bill Print Queue',
					queueType: 'Shared',
					releaser_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					releaserName: 'Peyton Smash',
					siding: 'Simplex',
					submitter_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					submitterName: 'Peyton Smash',
					tenant_id: '8c7c258e-58c9-4796-a18b-61fc556cbae9',
				},
				{
					result: '_result',
					table: 7,
					_start: '2024-02-08T19:42:08Z',
					_stop: '2025-06-04T20:44:58Z',
					_time: '2025-05-14T00:00:00Z',
					_value: 6,
					_field: 'pages',
					_measurement: 'job',
					device_id: '6d4f4e56-681a-4e83-9470-6307b99bf172',
					deviceModel: 'Nissan',
					deviceName: 'KMBCI 260i',
					deviceSerialNumber: '3be5fb12-4216-4819-88b0-76041664d802',
					filename: 'etr',
					job_id: 'fcb34020-4ebd-46ea-bd33-7438c8b5f1c9',
					queueName: 'Bill Print Queue',
					queueType: 'Shared',
					releaser_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					releaserName: 'Peyton Smash',
					siding: 'Duplex',
					submitter_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					submitterName: 'Peyton Smash',
					tenant_id: '8c7c258e-58c9-4796-a18b-61fc556cbae9',
				},
			],
		},
	},
};

const r2mDeviceReport = {
	data: {
		aggregate: {
			topDevice: 'MOCK OTHER DEVICE NAME HERE',
			topUser: 'MOCK OTHER USER NAME HERE',
		},
		bars: [
			{
				label: 'Device Name 1',
				value: 8,
			},
			{
				label: 'Device Name 2',
				value: 8,
			},
			{
				label: 'Device Name 3',
				value: 23,
			},
			{
				label: 'Device Name 4',
				value: 14,
			},
			{
				label: 'Device Name 5',
				value: 2,
			},
			{
				label: 'Device Name 6',
				value: 8,
			},
			{
				label: 'Device Name 7',
				value: 6,
			},
			{
				label: 'Device Name 8',
				value: 8,
			},

			{
				label: 'Device Name 9',
				value: 8,
			},
			{
				label: 'Device Name 10',
				value: 8,
			},
			{
				label: 'Device Name 11',
				value: 8,
			},
			{
				label: 'Device Name 12',
				value: 8,
			},
			{
				label: 'Device Name 13',
				value: 8,
			},
			{
				label: 'Device Name 14',
				value: 8,
			},
			{
				label: 'Device Name 15',
				value: 8,
			},
			{
				label: 'Device Name 16',
				value: 8,
			},
		],
		table: {
			head: {
				_time: '_time',
				deviceName: 'deviceName',
			},
			rows: [
				{
					result: '_result',
					table: 0,
					_start: '2024-02-08T19:42:08Z',
					_stop: '2025-06-04T20:44:58Z',
					_time: '2025-05-14T00:00:00Z',
					_value: 4,
					_field: 'pages',
					_measurement: 'job',
					device_id: 'ed2037a6-bd4b-47d4-b93f-5d7204a8b434',
					deviceModel: 'Ford',
					deviceName: 'Stark IXL5',
					deviceSerialNumber: 'daaf06e0-ba3d-489b-b6d6-593d50e28a70',
					filename: 'trer',
					job_id: '032a9a7f-4d04-46a4-99ec-137ea8e34b16',
					queueName: 'My Print Queue',
					queueType: 'Personal',
					releaser_id: '0649d073-6434-449b-a0f0-9120e2166946',
					releaserName: 'Dylan Crush',
					siding: 'Simplex',
					submitter_id: '0649d073-6434-449b-a0f0-9120e2166946',
					submitterName: 'Dylan Crush',
					tenant_id: '8c7c258e-58c9-4796-a18b-61fc556cbae9',
				},
				{
					result: '_result',
					table: 1,
					_start: '2024-02-08T19:42:08Z',
					_stop: '2025-06-04T20:44:58Z',
					_time: '2025-05-14T00:00:00Z',
					_value: 1,
					_field: 'pages',
					_measurement: 'job',
					device_id: '6d4f4e56-681a-4e83-9470-6307b99bf172',
					deviceModel: 'Nissan',
					deviceName: 'KMBCI 260i',
					deviceSerialNumber: '3be5fb12-4216-4819-88b0-76041664d802',
					filename: 'asdf',
					job_id: '27dcb48a-f4e0-4762-a1c7-f5afb2f2380b',
					queueName: 'My Print Queue',
					queueType: 'Personal',
					releaser_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					releaserName: 'Peyton Smash',
					siding: 'Simplex',
					submitter_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					submitterName: 'Peyton Smash',
					tenant_id: '8c7c258e-58c9-4796-a18b-61fc556cbae9',
				},
				{
					result: '_result',
					table: 2,
					_start: '2024-02-08T19:42:08Z',
					_stop: '2025-06-04T20:44:58Z',
					_time: '2025-05-14T00:00:00Z',
					_value: 3,
					_field: 'pages',
					_measurement: 'job',
					device_id: '6d4f4e56-681a-4e83-9470-6307b99bf172',
					deviceModel: 'Nissan',
					deviceName: 'KMBCI 260i',
					deviceSerialNumber: '3be5fb12-4216-4819-88b0-76041664d802',
					filename: 'qwefzxcb',
					job_id: '54d0a0f6-3794-4660-ae63-78cd677b2190',
					queueName: 'Bill Print Queue',
					queueType: 'Shared',
					releaser_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					releaserName: 'Peyton Smash',
					siding: 'Simplex',
					submitter_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					submitterName: 'Peyton Smash',
					tenant_id: '8c7c258e-58c9-4796-a18b-61fc556cbae9',
				},
				{
					result: '_result',
					table: 3,
					_start: '2024-02-08T19:42:08Z',
					_stop: '2025-06-04T20:44:58Z',
					_time: '2025-05-14T00:00:00Z',
					_value: 8,
					_field: 'pages',
					_measurement: 'job',
					device_id: '6d4f4e56-681a-4e83-9470-6307b99bf172',
					deviceModel: 'Nissan',
					deviceName: 'KMBCI 260i',
					deviceSerialNumber: '3be5fb12-4216-4819-88b0-76041664d802',
					filename: 'df',
					job_id: '639a8950-88ea-408f-951b-2770e8ebaa08',
					queueName: 'My Print Queue',
					queueType: 'Personal',
					releaser_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					releaserName: 'Peyton Smash',
					siding: 'Duplex',
					submitter_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					submitterName: 'Peyton Smash',
					tenant_id: '8c7c258e-58c9-4796-a18b-61fc556cbae9',
				},
				{
					result: '_result',
					table: 4,
					_start: '2024-02-08T19:42:08Z',
					_stop: '2025-06-04T20:44:58Z',
					_time: '2025-05-14T00:00:00Z',
					_value: 5,
					_field: 'pages',
					_measurement: 'job',
					device_id: '6d4f4e56-681a-4e83-9470-6307b99bf172',
					deviceModel: 'Nissan',
					deviceName: 'KMBCI 260i',
					deviceSerialNumber: '3be5fb12-4216-4819-88b0-76041664d802',
					filename: 'qwer',
					job_id: 'd3895a2b-e2a0-4b8b-a56d-1ba274e775f8',
					queueName: 'My Print Queue',
					queueType: 'Personal',
					releaser_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					releaserName: 'Peyton Smash',
					siding: 'Simplex',
					submitter_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					submitterName: 'Peyton Smash',
					tenant_id: '8c7c258e-58c9-4796-a18b-61fc556cbae9',
				},
				{
					result: '_result',
					table: 5,
					_start: '2024-02-08T19:42:08Z',
					_stop: '2025-06-04T20:44:58Z',
					_time: '2025-05-14T00:00:00Z',
					_value: 2,
					_field: 'pages',
					_measurement: 'job',
					device_id: '6d4f4e56-681a-4e83-9470-6307b99bf172',
					deviceModel: 'Nissan',
					deviceName: 'KMBCI 260i',
					deviceSerialNumber: '3be5fb12-4216-4819-88b0-76041664d802',
					filename: 'asdf',
					job_id: 'ecc8e6c9-3d34-4d71-bb85-9448f7a867aa',
					queueName: 'Bill Print Queue',
					queueType: 'Shared',
					releaser_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					releaserName: 'Peyton Smash',
					siding: 'Simplex',
					submitter_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					submitterName: 'Peyton Smash',
					tenant_id: '8c7c258e-58c9-4796-a18b-61fc556cbae9',
				},
				{
					result: '_result',
					table: 6,
					_start: '2024-02-08T19:42:08Z',
					_stop: '2025-06-04T20:44:58Z',
					_time: '2025-05-14T00:00:00Z',
					_value: 8,
					_field: 'pages',
					_measurement: 'job',
					device_id: '6d4f4e56-681a-4e83-9470-6307b99bf172',
					deviceModel: 'Nissan',
					deviceName: 'KMBCI 260i',
					deviceSerialNumber: '3be5fb12-4216-4819-88b0-76041664d802',
					filename: 'qergdfgs',
					job_id: 'f3a88c2c-a67a-4a28-99dc-bcd16b4cc8e6',
					queueName: 'Bill Print Queue',
					queueType: 'Shared',
					releaser_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					releaserName: 'Peyton Smash',
					siding: 'Simplex',
					submitter_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					submitterName: 'Peyton Smash',
					tenant_id: '8c7c258e-58c9-4796-a18b-61fc556cbae9',
				},
				{
					result: '_result',
					table: 7,
					_start: '2024-02-08T19:42:08Z',
					_stop: '2025-06-04T20:44:58Z',
					_time: '2025-05-14T00:00:00Z',
					_value: 6,
					_field: 'pages',
					_measurement: 'job',
					device_id: '6d4f4e56-681a-4e83-9470-6307b99bf172',
					deviceModel: 'Nissan',
					deviceName: 'KMBCI 260i',
					deviceSerialNumber: '3be5fb12-4216-4819-88b0-76041664d802',
					filename: 'etr',
					job_id: 'fcb34020-4ebd-46ea-bd33-7438c8b5f1c9',
					queueName: 'Bill Print Queue',
					queueType: 'Shared',
					releaser_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					releaserName: 'Peyton Smash',
					siding: 'Duplex',
					submitter_id: 'a84a06ff-c47c-44d5-9cc0-2cc82ee35d2d',
					submitterName: 'Peyton Smash',
					tenant_id: '8c7c258e-58c9-4796-a18b-61fc556cbae9',
				},
			],
		},
	},
};

const r2mExpiredPrintJobsReport = {
	data: {
		aggregate: {
			expiredJobs: 5,
			expiredUnreleasedJobs: 4,
			expiredPrintedAndKeptJobs: 1,
			totalUsers: 8,
		},
		bars: [
			{
				label: 'expiredUnreleasedJobs',
				value: 4,
			},
			{
				label: 'expiredPrintedAndKeptJobs',
				value: 1,
			},
			{
				label: 'totalUsers',
				value: 8,
			},
		],
		table: {
			head: {
				filename: 'filename',
				released: 'released',
				submitterName: 'user',
				queueName: 'queueName',
				queueType: 'queueType',
			},
			rows: [],
		},
	},
};

const r2mUsersReport = r2mDeviceReport;
const r2mPrintJobsReport = r2mDeviceReport;
const r2mUnreleasedPrintJobsReport = r2mDeviceReport;

const r2mSystemPrintQueueReport = {
	data: {
		aggregate: {
			unreleasedFiles: 3,
			printedFiles: 5,
			expiredUnreleasedJobs: 2,
			totalUsers: 4,
		},
		bars: [
			{ label: 'unreleasedFiles', value: 3 },
			{ label: 'printedFiles', value: 5 },
			{ label: 'expiredUnreleasedJobs', value: 2 },
			{ label: 'totalUsers', value: 4 },
		],
		table: {
			head: {
				filename: 'filename',
				status: 'status',
				senderEmail: 'senderEmail',
				submittedDate: 'submittedDate',
				expirationDate: 'expirationDate',
			},
			rows: [
				{
					filename: 'guest-document.pdf',
					status: 'unreleased',
					senderEmail: 'guest@hotel.com',
					submittedDate: '2025-11-06T10:30:00Z',
					expirationDate: '2025-11-07T10:30:00Z',
				},
				{
					filename: 'boarding-pass.pdf',
					status: 'printed',
					senderEmail: 'traveler@email.com',
					submittedDate: '2025-11-05T14:20:00Z',
					expirationDate: '2025-11-06T14:20:00Z',
				},
			],
		},
	},
};

const bsnDeviceEventsReport = {
	data: {
		aggregate: {},
		bars: [
			{
				label: 'SECURE',
				value: [0, 0, 1, 0, 0, 1, 1],
			},
			{
				label: 'UNSECURED',
				value: [0, 0, 2, 1, 0, 0, 0],
			},
			{
				label: 'UNKNOWN',
				value: [0, 0, 0, 0, 0, 0, 0],
			},
		],
		table: {
			head: {
				securityStatus: 'securityStatus',
				deviceName: 'deviceName',
				deviceGroupName: 'deviceGroupName',
				deviceSerialNumber: 'deviceSerialNumber',
				deviceIpAddress: 'deviceIpAddress',
				deviceDescription: 'deviceDescription',
				_time: '_time',
			},
			rows: [
				{
					_time: '2025-11-04T00:00:00Z',
					securityStatus: 'Secure',
					securityStatusKey: 'SECURE',
					deviceName: 'Device Name 1',
					deviceGroupName: 'Device Group Name 1',
					deviceSerialNumber: 'Device Serial Number 1',
					deviceIpAddress: 'Device IP Address 1',
					deviceDescription: 'Device Description 1',
				},
				{
					_time: '2025-11-05T10:15:00Z',
					securityStatus: 'Not Secure',
					securityStatusKey: 'UNSECURED',
					deviceName: 'Device Name 2',
					deviceGroupName: 'Device Group Name 2',
					deviceSerialNumber: 'Device Serial Number 2',
					deviceIpAddress: 'Device IP Address 2',
					deviceDescription: 'Device Description 2',
				},
				{
					_time: '2025-11-05T11:20:00Z',
					securityStatus: 'Not Secure',
					securityStatusKey: 'UNSECURED',
					deviceName: 'Device Name 3',
					deviceGroupName: 'Device Group Name 3',
					deviceSerialNumber: 'Device Serial Number 3',
					deviceIpAddress: 'Device IP Address 3',
					deviceDescription: 'Device Description 3',
				},
			],
		},
	},
};

export const reportByType = {
	'r2m-executive': r2mExecutiveReport,
	'r2m-users': r2mUsersReport,
	'r2m-devices': r2mDeviceReport,
	'r2m-print-jobs': r2mPrintJobsReport,
	'r2m-unreleased-print-jobs': r2mUnreleasedPrintJobsReport,
	'r2m-expired-print-jobs': r2mExpiredPrintJobsReport,
	'r2m-system-print-queue': r2mSystemPrintQueueReport,
	'bsn-device-events': bsnDeviceEventsReport,
} as const satisfies { [key in ReportType]: unknown };
